import React from "react";
import DataChangedProvider from "./DataChangedProvider";
import DataProvider from "./DataProvider";
import EntitiesProvider from "./EntitiesProvider";
import HistoryPeriodProvider from "./HistoryPeriodProvider";
import LoggedInUserProvider from "./LoggedInUserProvider";
import { RibbonProvider } from "./RibbonProvider";
import SelectedEntityProvider from "./SelectedEntityProvider";
import SelectedRowsProvider from "./SelectedRowsProvider";
import SelectedTabProvider from "./SelectedTabProvider";

interface ProviderWrapperProps {
  children: React.ReactNode;
}

const ProviderWrapper = (props: ProviderWrapperProps) => {
  return (
    <SelectedEntityProvider>
      <LoggedInUserProvider>
        <EntitiesProvider>
          <DataProvider>
            <SelectedRowsProvider>
              <SelectedTabProvider>
                <RibbonProvider>
                  <HistoryPeriodProvider>
                    <DataChangedProvider>{props.children}</DataChangedProvider>
                  </HistoryPeriodProvider>
                </RibbonProvider>
              </SelectedTabProvider>
            </SelectedRowsProvider>
          </DataProvider>
        </EntitiesProvider>
      </LoggedInUserProvider>
    </SelectedEntityProvider>
  );
};

export default ProviderWrapper;
